/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  DailyVote,
  DailyVoteFromJSON,
  DailyVoteFromJSONTyped,
  DailyVoteToJSON,
  KeyValuePair2,
  KeyValuePair2FromJSON,
  KeyValuePair2FromJSONTyped,
  KeyValuePair2ToJSON,
  VoteResult,
  VoteResultFromJSON,
  VoteResultFromJSONTyped,
  VoteResultToJSON,
} from "./";

/**
 *
 * @export
 * @interface VoteResults
 */
export interface VoteResults {
  /**
   *
   * @type {number}
   * @memberof VoteResults
   */
  vimeoAlbumId?: number;
  /**
   *
   * @type {Array<VoteResult>}
   * @memberof VoteResults
   */
  results: Array<VoteResult>;
  /**
   *
   * @type {Array<DailyVote>}
   * @memberof VoteResults
   */
  votesPerDay: Array<DailyVote>;
  /**
   *
   * @type {number}
   * @memberof VoteResults
   */
  inactiveVotes?: number;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof VoteResults
   */
  inactiveVotesReminded?: { [key: string]: number } | null;
  /**
   *
   * @type {string}
   * @memberof VoteResults
   */
  reminderIntervals: string;
  /**
   *
   * @type {number}
   * @memberof VoteResults
   */
  minDaysBeforeReminder?: number;
  /**
   *
   * @type {number}
   * @memberof VoteResults
   */
  reminderHour?: number;
  /**
   *
   * @type {Array<KeyValuePair2>}
   * @memberof VoteResults
   */
  reminders: Array<KeyValuePair2>;
}

export function VoteResultsFromJSON(json: any): VoteResults {
  return VoteResultsFromJSONTyped(json, false);
}

export function VoteResultsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoteResults {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    vimeoAlbumId: !exists(json, "vimeoAlbumId")
      ? undefined
      : json["vimeoAlbumId"],
    results: (json["results"] as Array<any>).map(VoteResultFromJSON),
    votesPerDay: (json["votesPerDay"] as Array<any>).map(DailyVoteFromJSON),
    inactiveVotes: !exists(json, "inactiveVotes")
      ? undefined
      : json["inactiveVotes"],
    inactiveVotesReminded: !exists(json, "inactiveVotesReminded")
      ? undefined
      : json["inactiveVotesReminded"],
    reminderIntervals: json["reminderIntervals"],
    minDaysBeforeReminder: !exists(json, "minDaysBeforeReminder")
      ? undefined
      : json["minDaysBeforeReminder"],
    reminderHour: !exists(json, "reminderHour")
      ? undefined
      : json["reminderHour"],
    reminders: (json["reminders"] as Array<any>).map(KeyValuePair2FromJSON),
  };
}

export function VoteResultsToJSON(value?: VoteResults | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    vimeoAlbumId: value.vimeoAlbumId,
    results: (value.results as Array<any>).map(VoteResultToJSON),
    votesPerDay: (value.votesPerDay as Array<any>).map(DailyVoteToJSON),
    inactiveVotes: value.inactiveVotes,
    inactiveVotesReminded: value.inactiveVotesReminded,
    reminderIntervals: value.reminderIntervals,
    minDaysBeforeReminder: value.minDaysBeforeReminder,
    reminderHour: value.reminderHour,
    reminders: (value.reminders as Array<any>).map(KeyValuePair2ToJSON),
  };
}
